//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  computed: {
    buttonFontSize () {
      return this.isMobile() ? 'sm' : 'md'
    }
  },
  methods: {
    trackContactClicked () {
      this.addDDAction('Contact business clicked')
      location.hash = ''
      location.hash = '#contact-form'
    }
  }
}
